import { gql } from "@apollo/client";

const CREATE_LEAGUE = gql`
  mutation createLeagueInput(
    $title: String!
    $type: LeagueGeoScope!
    $abbreviation: String!
    $priority: String!
    $sports: Int
    $discipline: String
    $enableRankings: Boolean
    $enableLicense: Boolean
    $enableOnlinePayments: Boolean
    $status: String
    $email: String
    $website: String
    $phone: String
    $instagram: String
    $federationPublicId: String!
    $platformPublicId: String!
    $abbreviationLogo: Upload
    $file: Upload
    $country: String
    $isFeatured: Boolean
    $createFactSheetInput: [CreateFactSheetInput!]!
    $allowUnregisteredPlayers: Boolean
    $requireTournamentApproval: Boolean
    $globalCategoryLimitPerPlayer: Float
    $bannerCover: Upload
    $liveStreaming_sporfie_key: String
    $isTournatedFeeVatEnable: Boolean
    $tournatedFeeVat: Float
    $isCustomFeeEnable: Boolean
    $customFee: [CreatePlatformFeeInput!]
  ) {
    createLeague(
      createLeagueInput: {
        title: $title
        type: $type
        abbreviation: $abbreviation
        federationPublicId: $federationPublicId
        priority: $priority
        sports: $sports
        discipline: $discipline
        enableRankings: $enableRankings
        enableLicense: $enableLicense
        enableOnlinePayments: $enableOnlinePayments
        status: $status
        email: $email
        website: $website
        phone: $phone
        instagram: $instagram
        abbreviationLogo: $abbreviationLogo
        logo: $file
        platformPublicId: $platformPublicId
        country: $country
        isFeatured: $isFeatured
        allowUnregisteredPlayers: $allowUnregisteredPlayers
        requireTournamentApproval: $requireTournamentApproval
        globalCategoryLimitPerPlayer: $globalCategoryLimitPerPlayer
        bannerCover: $bannerCover
        liveStreaming_sporfie_key: $liveStreaming_sporfie_key
        isTournatedFeeVatEnable: $isTournatedFeeVatEnable
        tournatedFeeVat: $tournatedFeeVat
        isCustomFeeEnable: $isCustomFeeEnable
      }
      customFee: $customFee
      createFactSheetInput: $createFactSheetInput
    ) {
      title
      type
      status
      email
      website
      id
    }
  }
`;

export default CREATE_LEAGUE;
